import { Injectable } from "@angular/core";
import { ApicallService } from "@core-services/apicall.service";
import { map } from "rxjs/operators";
import { BasicApiObject, parseApiResponseObject } from "@helpers/functions";
import { WalletBalanceAdapter } from "@modules/+new/core/wallets-balances/domain/entities/wallet-balance.model";
import { Observable } from "rxjs";
import { WalletBalanceState } from "@modules/+new/core/wallets-balances/domain/+state/wallets-balances.state.service";
import { WalletsBalancesApiResponse } from "@modules/+new/core/wallets-balances/domain/entities/wallets-balances-response.api.model";

@Injectable({
	providedIn: "root"
})
export class WalletsBalancesRemoteService {
	constructor(private readonly apicallService: ApicallService) {}

	public getBalances$(): Observable<Omit<WalletBalanceState, "loaded">> {
		return this.apicallService.get("user/balances").pipe(
			map((value) => parseApiResponseObject(value as unknown as BasicApiObject)),
			map((value: WalletsBalancesApiResponse) => ({
				hasUnconfirmedBalance: value.has_unconfirmed_balance,
				fiatWalletsBalances: WalletBalanceAdapter.adaptMany(value.fiat_wallets),
				cryptoWalletsBalances: WalletBalanceAdapter.adaptMany(value.cryptocoin_wallets)
			}))
		);
	}
}
